import { useMutation } from "react-query";
import { userApi } from "../../api";

export const useDeleteUser = () => {
  const mutation = useMutation((id: number): any => {
    return userApi.delete(id);
  });
  return mutation;
};
